import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import {HashLink} from 'react-router-hash-link';


class Hashish extends Component {
    render() {
        return (
            <div>
                <Navbar head="Hashish" />
            <div className="container" style={{marginTop:"50px"}}>
            <HashLink to='/faq#hashish'>
                <button id="myBtn" title="FAQ">
                <i class="fas fa-info-circle faqicon"></i> 
                    <p>  FAQ</p>
                </button>
                </HashLink>
                
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        <div id="imgcarousel" className="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#imgcarousel" data-slide-to="0" class="active"></li>
                                <li data-target="#imgcarousel" data-slide-to="1"></li>
                                <li data-target="#imgcarousel" data-slide-to="2"></li>
                            </ol>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img className="img-fluid" src="/assests/images/cannibus.jpg" alt="">
                                    </img>

                                </div>
                                <div className="carousel-item">
                                    <img className="img-fluid" src="/assests/images/cannibus.jpg" alt=""> 
                                    </img>

                                </div>
                                <div className="carousel-item">
                                    <img className="img-fluid" src="/assests/images/cannibus.jpg" alt="">
                                    </img>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <h2>Cigeratte</h2>
                    <p> this is a text ... efne/klfwe.ewgkewlgn</p>
                </div>
            </div>
            </div>
        )
    }
}

export default Hashish;